import SectionTitle from "@/components/base/SectionTitle";

const issues = [
  {
    icon: "ri-user-search-line",
    title: "施暴者到底是谁",
    desc: "把匿名账号还原成可分类的人：情绪宣泄者、从众跟风者与职业牟利者，动机完全不同，应对方式也应当不同。",
  },
  {
    icon: "ri-repeat-2-line",
    title: "键盘侠为什么整齐划一",
    desc: "当评论区出现大量可互相替换的相似文案，它大概率不是自然形成的舆论，而是一次有组织的输出。",
  },
  {
    icon: "ri-money-cny-circle-line",
    title: "水军产业链的定价逻辑",
    desc: "按曝光量计费、按账号等级分档、按项目整体报价，网暴之所以来势汹汹，因为它可以被算成一张预算表。",
  },
  {
    icon: "ri-spy-line",
    title: "谁在借刀杀人",
    desc: "最危险的施暴者从不亲自出现在评论区，他们只负责提供燃料，然后看着一群愤怒的人替自己完成攻击。",
  },
];

export default function IssuesSection() {
  return (
    <section id="issues" className="w-full bg-background-50 py-14 md:py-20 scroll-mt-[72px]">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionTitle
              eyebrow="Core Issues"
              title="我们只追问四个问题"
              description="每一起网暴黑料都值得被当成样本，而不是谈资。顺着下面四条线索往下走，热度背后的人和钱会慢慢浮出来。"
            />
            <div className="mt-6 p-5 rounded-lg bg-secondary-50 border border-secondary-200">
              <p className="text-sm leading-relaxed text-secondary-900">
                <strong className="font-semibold">一条基本原则：</strong>
                我们从不评价个案中谁更可怜，只分析机制如何运转。因为只有机制被讲清楚，下一次才不会有人白白被牺牲。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            {issues.map((item, index) => (
              <article
                key={item.title}
                className="group flex gap-4 md:gap-5 py-5 first:pt-0 border-b border-background-200 last:border-b-0"
              >
                <span className="shrink-0 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-md bg-background-100 text-primary-600 group-hover:bg-primary-100 transition-colors">
                  <i className={`${item.icon} text-xl md:text-2xl`} aria-hidden="true"></i>
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-baseline gap-2">
                    <span className="font-heading text-xs text-accent-700 font-bold">
                      0{index + 1}
                    </span>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}